/**
 * Which side of the product a build is for.
 *
 * One codebase, two public faces: the real app (production, UAT), which has
 * no demo in it at all, and the demo link, which has nothing but the demo.
 * The choice is made at build time by VITE_SITE_MODE, so the other side is
 * simply not routed in that build. Left unset, as on a dev machine, both are
 * there, since a developer needs both.
 */
export type SiteMode = 'app' | 'demo' | 'all';

export function resolveSiteMode(raw: string | undefined): SiteMode {
  return raw === 'app' || raw === 'demo' ? raw : 'all';
}

export const SITE_MODE: SiteMode = resolveSiteMode(import.meta.env.VITE_SITE_MODE);
/** The real app's pages (sign-in, portals) are in this build. */
export const HAS_APP = SITE_MODE !== 'demo';
/** The demo's pages are in this build. */
export const HAS_DEMO = SITE_MODE !== 'app';

/** Where the demo lives now. The real app (production, UAT) has no demo of
 *  its own, but /demo links from before it moved are still in testing steps
 *  and emails, so they are sent here. */
export const DEMO_SITE_URL = (import.meta.env.VITE_DEMO_SITE_URL as string | undefined)
  || 'https://demo-covermyclass-d5beeaffbveqbba7.z01.azurefd.net';

/** The demo-site address for an old /demo link on the app, keeping its path
 *  and query; null when this build has its own demo or the path is not one. */
export function demoRedirectTarget(mode: SiteMode, path: string, search: string): string | null {
  if (mode !== 'app' || !/^\/demo(\/|$)/i.test(path)) return null;
  return `${DEMO_SITE_URL}${path}${search}`;
}
